import { Action, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';

import * as CustomerActions from './customers.actions';
import { ICustomersStateModel } from '../models/customers.model';

export type State = ICustomersStateModel;
export const initialState: Readonly<State> = {
  list: [],
  loadingCustomers: false,
  loader: false,
  customerSaved: null
};

const customerReducer = createReducer(
  initialState,
  on(
    CustomerActions.GetCustomersList,
    (state): State => ({
      ...state,
      loadingCustomers: true
    })
  ),
  on(
    CustomerActions.GetCustomersListSuccess,
    (state, { customersList }): State => ({
      ...state,
      list: customersList.map((customer) => ({ ...customer, domains: customer.domains ?? [] })),
      loadingCustomers: false
    })
  ),
  on(
    CustomerActions.GetCustomersListFailed,
    (state): State => ({
      ...state,
      loadingCustomers: false
    })
  ),
  on(
    CustomerActions.CreateCustomer,
    (state): State => ({
      ...state,
      loader: true,
      customerSaved: null
    })
  ),
  on(
    CustomerActions.CreateCustomerSuccess,
    (state, { newSavedCustomer }): State => ({
      ...state,
      list: [...state.list, newSavedCustomer],
      loader: false,
      customerSaved: true
    })
  ),
  on(
    CustomerActions.CreateCustomerFailed,
    (state): State => ({
      ...state,
      loader: false,
      customerSaved: null
    })
  ),
  on(
    CustomerActions.UpdateCustomer,
    (state): State => ({
      ...state,
      loader: true
    })
  ),
  on(
    CustomerActions.UpdateCustomerSuccess,
    (state, { updateSavedCustomer }): State => ({
      ...state,
      loader: false,
      list: state.list.map((customer) =>
        customer._id === updateSavedCustomer._id ? { ...customer, ...updateSavedCustomer } : customer
      )
    })
  ),
  on(
    CustomerActions.UpdateCustomerFailed,
    (state): State => ({
      ...state,
      loader: false
    })
  ),
  on(
    CustomerActions.ResetCustomerSaveState,
    (state): State => ({
      ...state,
      customerSaved: null
    })
  )
);

const customerState = createFeatureSelector<State>('customers');

export const reducer = (state: State, action: Action): State => customerReducer(state, action);

export const getCustomersList = createSelector(customerState, (state: ICustomersStateModel) => state.list);

export const getLoaderState = createSelector(customerState, (state: ICustomersStateModel) => state.loader);

export const getCustomerSavedStatus = createSelector(customerState, (state: ICustomersStateModel) => state.customerSaved);
